import { useContext } from 'react';
import {
  NewStripeCardFormContext,
} from './Context.NewCard';
import { NewPaymentMethodContext } from './Context.NewPayment';

export const useStripeNewCardForm = () => useContext(NewStripeCardFormContext);
export const usePaymentMethod = () => useContext(NewPaymentMethodContext);